<template>
	<v-row class="header" v-if="formattedData">
		<v-col offset="2" cols="8">
			<img :src="formattedData.srcImage" class="image" />

			<div :class="'target color-' + (formattedData.target ? formattedData.target.slug : 'all')">
				<span class="font-weight-bold">Evento </span>
				<span class="separator" v-if="formattedData.target">&bull;</span>
				<span v-if="formattedData.target">{{ formattedData.target.name }}</span>
			</div>
			<h1 class="font-size-50">{{ formattedData.title }}</h1>
			<h2 class="font-size-35" v-if="formattedData.cardInfo.subtitle_article">
				{{ formattedData.cardInfo.subtitle_article }}
			</h2>
			<div class="button" v-if="formattedData.cardInfo.button_url">
				<v-btn
					:color="formattedData.target ? colorsObject[formattedData.target.slug] : colorsObject['all']"
					depressed
					class="loanButton white--text"
					:href="formattedData.cardInfo.button_url"
					target="_blank"
				>
					{{ formattedData.cardInfo.button_label || 'Maggiori info' }}
				</v-btn>
			</div>
		</v-col>
	</v-row>
</template>

<script>
import { formatCategoriesAndTargets } from "@/mixins/formatCategoriesAndTargets";
import { GET_EVENT, GET_EVENT_PREVIEW } from "@/queries/Events.js";

export default {
	data() {
		return {
			formattedData: null
		};
	},
	mixins: [formatCategoriesAndTargets],
	props: {
		eventSlug: {
			type: String,
			default: null,
			required: true
		}
	},
	computed: {
		pageColor() {
			return this.formattedData && this.formattedData.target 
				? this.colorsObject[this.formattedData.target.slug]
				: this.colorsObject['all'];
		}
	},
	async mounted() {
		if (this.eventSlug) {
			let query;
			let isPreview = this.$route.query && this.$route.query.preview;
			
			if (isPreview) {
				query = {
					query: GET_EVENT_PREVIEW(this.eventSlug)
				};
			} else {
				query = {
					query: GET_EVENT(this.eventSlug)
				};
			}
			
			let data = await this.$apollo.query(query);
			
			if (isPreview) {
				data = data && data.data && data.data.event || false;
			} else {
				data = data && data.data && data.data.events && data.data.events.nodes && data.data.events.nodes[0]
					? data.data.events.nodes[0] 
					: false;
			}
			
			if (data) {
				data.blocks = JSON.parse("[" + data.blocksJSON + "]")[0];
				let newData = this.formatCategoriesAndTargets(data)[0];
				let cardInfo = {};
				
				// Prende le info dal primo blocco se esiste
				if (newData.blocks && newData.blocks[0] && newData.blocks[0].attributes && newData.blocks[0].attributes.fields) {
					cardInfo = JSON.parse(newData.blocks[0].attributes.fields);
				}
				
				this.formattedData = {
					title: newData.title,
					cardInfo: cardInfo,
					blocks: newData.blocks.slice(1, newData.length),
					srcImage: newData.featuredImage
						? newData.featuredImage.node.sourceUrl
						: "/wp-content/uploads/2020/11/no-iamge-placeholder.jpg",
					target: newData.target
				};
			}
		}
	}
};
</script>

<style lang="scss" scoped>
h1 {
	padding-bottom: $spacing-0;
}
h2 {
	font-weight: normal;
	padding-bottom: $spacing-1;
}
.target {
	padding-bottom: $spacing-0;
	text-transform: uppercase;
	font-size: $font-size-14;
}
.header {
	padding-top: $spacing-1 !important;
}
.image {
	margin: auto;
	aspect-ratio: 4/3;
	max-height: 300px;
	object-fit: contain;
	position: relative;
	transform: translateX(-50%);
    left: 50%;
}
.loanButton {
	border-radius: 50px 50px 50px 5px;
}

@media only screen and (max-width: 768px) {
	#app .col {
		width: 90%;
		max-width: 90%;
		margin: auto;
	}
	#app h1 {
		font-size: $font-size-35;
	}
	.image {
		max-width: 100%;
	}
}
@media only screen and (max-width: 480px) {
	.image {
		margin: auto;
		height: 200px;
		width: 200px;
	}
}
</style>

<style lang="scss">
.menu-event {
	background: white !important;
	color: black !important;
	* {
		color: black !important;
	}

	.bar-icon {
		background: black !important;
	}

	.open {
		color: white !important;
	}

}

</style>